export const AppLinks = {
  TermsOfAgreementLink: `${process.env.REACT_APP_WINDOW_OPENER_URL}/website-terms-of-service`,
  PostalCodeSearchLink:
    'https://israelpost.co.il/%D7%A9%D7%99%D7%A8%D7%95%D7%AA%D7%99%D7%9D/%D7%90%D7%99%D7%AA%D7%95%D7%A8-%D7%9E%D7%99%D7%A7%D7%95%D7%93/',
  PrivacyPolicyLink: `${process.env.REACT_APP_WINDOW_OPENER_URL}/privacy-policy`,
}
